import {MD_WIDTH} from '@main/helpers/consts.js';
/**
 * Класс для управления мобильным меню
 * @class MobileMenu
 */
class MobileMenu {
  /**
   * Создает экземпляр MobileMenu
   * @constructor
   */
  constructor(menu) {
    this.menu = menu;
    this.burger = this.menu.nextElementSibling;

    this.isOpen = false;
    this.activeMenuClass = 'is-open';
    this.activeBurgerClass = 'is-active';
    this.breakpoint = MD_WIDTH;

    // Привязка контекста для обработчиков событий
    this.handleBurgerClick = this.handleBurgerClick.bind(this);
    this.handleDocumentClick = this.handleDocumentClick.bind(this);
    this.handleResize = this.handleResize.bind(this);

    this.init();
  }

  /**
   * Инициализирует меню, добавляя обработчики событий
   * @method
   */
  init() {
    if (this.isMobile()) {
      this.activate();
    } else {
      this.deactivate();
    }

    window.addEventListener('resize', this.handleResize);
  }

  /**
   * Проверяет, является ли текущий экран мобильным
   * @method
   * @returns {boolean} - true если экран меньше breakpoint
   */
  isMobile() {
    return window.innerWidth < this.breakpoint;
  }

  /**
   * Активирует функциональность мобильного меню
   * @method
   */
  activate() {
    this.burger.addEventListener('click', this.handleBurgerClick);
    document.addEventListener('click', this.handleDocumentClick);
    this.addMenuLinkListeners();
  }

  /**
   * Деактивирует функциональность мобильного меню
   * @method
   */
  deactivate() {
    this.burger.removeEventListener('click', this.handleBurgerClick);
    document.removeEventListener('click', this.handleDocumentClick);

    // Закрываем меню, если оно было открыто
    if (this.isOpen) {
      this.closeMenu();
    }
  }

  /**
   * Обрабатывает изменение размера окна
   * @method
   */
  handleResize() {
    if (this.isMobile()) {
      // Если перешли на мобильный вид и меню не активно
      if (!this.burger.classList.contains('has-listener')) {
        this.activate();
        this.burger.classList.add('has-listener');
      }
    } else {
      // Если перешли на десктопный вид
      this.deactivate();
      this.burger.classList.remove('has-listener');
    }
  }

  /**
   * Обрабатывает клик по бургеру
   * @method
   * @param {Event} event - Событие клика
   */
  handleBurgerClick(event) {
    event.stopPropagation();

    if (this.isOpen) {
      this.closeMenu();
    } else {
      this.openMenu();
    }
  }

  /**
   * Обрабатывает клик по документу для закрытия меню при клике вне его
   * @method
   * @param {Event} event - Событие клика
   */
  handleDocumentClick(event) {
    // Если меню открыто и клик был вне навигации и вне бургера - закрываем меню
    if (this.isOpen && !this.menu.contains(event.target) && !this.burger.contains(event.target)) {
      this.closeMenu();
    }
  }

  /**
   * Добавляет обработчики для ссылок внутри меню
   * @method
   */
  addMenuLinkListeners() {
    const menuLinks = this.menu.querySelectorAll('a');

    menuLinks.forEach((link) => {
      link.removeEventListener('click', this.handleMenuLinkClick);
    });

    this.handleMenuLinkClick = () => {
      if (this.isOpen) {
        this.closeMenu();
      }
    };

    menuLinks.forEach((link) => {
      link.addEventListener('click', this.handleMenuLinkClick);
    });
  }

  /**
   * Открывает меню
   * @method
   */
  openMenu() {
    this.burger.classList.add(this.activeBurgerClass);
    this.menu.classList.add(this.activeMenuClass);
    this.isOpen = true;
  }

  /**
   * Закрывает меню
   * @method
   */
  closeMenu() {
    this.burger.classList.remove(this.activeBurgerClass);
    this.menu.classList.remove(this.activeMenuClass);
    this.isOpen = false;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.js-header-menu').forEach((menu) => {
    new MobileMenu(menu);
  });
});
